import { render, staticRenderFns } from "./SolicitarVacaciones.vue?vue&type=template&id=56b4e5c4&"
import script from "./SolicitarVacaciones.vue?vue&type=script&lang=js&"
export * from "./SolicitarVacaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports